<template>
    <div class="upfluence-profile">
        <div class="overall-stats">
            <h4>Across all platforms</h4>
            <!-- across all platform first row (social reach, engagements, real followers )-->
            <div class="overall-audience-data">
                <div class="social-reach">
                    <h2 class="social-reach-data">
                        {{
                            this.formatSummedValue(
                                this.parsedUpfluenceData.overall_stats.socialReach
                            )
                        }}
                    </h2>
                    <p>Social</p>
                    <p>Reach</p>
                </div>
                <div class="total-engagement">
                    <h2 class="total-engagement-data">
                        {{
                            this.formatPercentages(
                                this.parsedUpfluenceData.overall_stats.engagementRate
                            )
                        }}
                    </h2>
                    <p>Total</p>
                    <p>engagement</p>
                </div>
                <div class="real-followers">
                    <h2 class="real-followers-data">
                        {{
                            this.formatPercentages(
                                this.parsedUpfluenceData.overall_stats.realFollowers
                            )
                        }}
                    </h2>
                    <p>Real</p>
                    <p>Followers</p>
                </div>
            </div>

            <!-- across all platform second row (various demographics) -->
            <div class="overall-demographics-data">
                <!-- across all platform second row first column gender demographics -->
                <div class="gender-demographics">
                    <div class="male-data">
                        <h2>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                fill="currentColor"
                                class="bi bi-gender-male"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.707L9.871 6.836a5 5 0 1 1-.707-.707L13.293 2H9.5zM6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
                                />
                            </svg>
                            {{
                                this.formatPercentages(
                                    this.parsedUpfluenceData.overall_stats.genderStat.male
                                )
                            }}
                        </h2>
                    </div>
                    <div class="female-data">
                        <h2>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                fill="currentColor"
                                class="bi bi-gender-female"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM3 5a5 5 0 1 1 5.5 4.975V12h2a.5.5 0 0 1 0 1h-2v2.5a.5.5 0 0 1-1 0V13h-2a.5.5 0 0 1 0-1h2V9.975A5 5 0 0 1 3 5z"
                                />
                            </svg>
                            {{
                                this.formatPercentages(
                                    this.parsedUpfluenceData.overall_stats.genderStat.female
                                )
                            }}
                        </h2>
                    </div>
                </div>

                <!-- across all platform second row second column age demographics -->
                <div class="age-demographics" v-if="!emptyAgeStats">
                    <div
                        class="age-stats-container"
                        v-for="(prcnt, ar) in topThreeAgeGroupData"
                        :key="ar"
                    >
                        <div class="age-range">
                            <p>{{ ar }}</p>
                        </div>
                        <div class="bootstrap-progressbar">
                            <div class="progress">
                                <div
                                    class="progress-bar"
                                    role="progressbar"
                                    :style="{
                                        width: formatProgress(formatPercentages(prcnt)) + '%'
                                    }"
                                    :aria-valuenow="formatProgress(formatPercentages(prcnt))"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ formatPercentages(prcnt) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="age-stats-label">
                        <p>Age</p>
                    </div>
                </div>
                <div class="empty-age-stats" v-else>
                    <p>Age data: N/A</p>
                </div>

                <!-- across all platform second row third column country demographics -->
                <div
                    class="countries-demographics"
                    v-if="Object.keys(parsedUpfluenceData.overall_stats.countriesStat).length"
                >
                    <div
                        class="countries-stats-container"
                        v-for="(prcnt, cn) in parsedUpfluenceData.overall_stats.countriesStat"
                        :key="cn"
                    >
                        <div class="country-name">
                            <p>{{ cn }}</p>
                        </div>
                        <div class="bootstrap-progressbar">
                            <div class="progress">
                                <div
                                    class="progress-bar"
                                    role="progressbar"
                                    :style="{
                                        width: formatProgress(formatPercentages(prcnt)) + '%'
                                    }"
                                    :aria-valuenow="formatProgress(formatPercentages(prcnt))"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ formatPercentages(prcnt) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="countries-stats-label">
                        <p>Countries</p>
                    </div>
                </div>
                <div class="empty-countries-stats" v-else>
                    <p>Countries data: N/A</p>
                </div>

                <!-- across all platform second row fourth column city demographics -->
                <div
                    class="cities-demographics"
                    v-if="Object.keys(parsedUpfluenceData.overall_stats.citiesStat).length"
                >
                    <div
                        class="cities-stats-container"
                        v-for="(prcnt, ct) in parsedUpfluenceData.overall_stats.citiesStat"
                        :key="ct"
                    >
                        <div class="city-name">
                            <p>
                                {{ ct }}
                            </p>
                        </div>
                        <div class="bootstrap-progressbar">
                            <div class="progress">
                                <div
                                    class="progress-bar"
                                    role="progressbar"
                                    :style="{
                                        width: formatProgress(formatPercentages(prcnt)) + '%'
                                    }"
                                    :aria-valuenow="formatProgress(formatPercentages(prcnt))"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                >
                                    {{ formatPercentages(prcnt) }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cities-stats-label">
                        <p>Cities</p>
                    </div>
                </div>
                <div class="empty-cities-stats" v-else>
                    <p>Cities data: N/A</p>
                </div>
            </div>
        </div>

        <hr class="hr-divider" />
        <div class="specific-stats">
            <h4>Platform-specific stats</h4>

            <!-- specific platform data -->
            <div
                class="platform-specific-container"
                v-if="platformSpecificFormattedData.length != 0"
            >
                <div
                    class="individual-platform"
                    v-for="pltfm in platformSpecificFormattedData"
                    :key="pltfm.platform"
                >
                    <div class="data-container" v-for="(val, key) in pltfm" :key="key">
                        <div class="platform-icon" v-if="key === 'platform'">
                            <img :src="icons[val]" alt="platform-icon" />
                        </div>
                        <div class="platform-data" v-else>
                            <h2>{{ val }}</h2>
                            <p>{{ formatPltfmSpcfcDatakeys(key) }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="empty-specific-stats" v-else><p>N/A</p></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'UpfluenceProfile',

        props: {
            upfluenceData: {
                type: String,
                required: true,
                default: JSON.stringify('emptyData'),
                validator(val) {
                    try {
                        return !!(JSON.parse(val) && val)
                    } catch (e) {
                        return false
                    }
                }
            }
        },

        data() {
            return {
                parsedUpfluenceData: {},
                socialPlatforms: [
                    'facebooks',
                    'twitters',
                    'instagrams',
                    'youtubes',
                    'tiktoks',
                    'pinterests',
                    'twitches'
                ],
                prcntFmtKeys: ['engagement_rate'],
                summedFmtKeys: [
                    'followers',
                    'average_likes',
                    'average_comments',
                    'average_views',
                    'average_retweets',
                    'average_favorites'
                ],
                icons: {
                    facebooks: '/images/facebook-icon.svg',
                    twitters: '/images/icons/social/twitter.png',
                    instagrams: '/images/instagram-icon.svg',
                    youtubes: '/images/icons/social/youtube.png',
                    tiktoks: '/images/icons/social/tiktok.png',
                    pinterests: '/images/icons/social/pinterest.png',
                    twitches: '/images/icons/social/twitch.png'
                }
            }
        },

        created() {
            this.initUpfluenceData()
        },

        /**
         * to add pinterest and twitch data points: edit method:
         *	fetchPltfmDemogrphcsCollection
         *	(needs two keys besides followers and engagment)
         */
        methods: {
            initUpfluenceData() {
                for (const [key, val] of Object.entries(JSON.parse(this.upfluenceData))) {
                    this.$set(this.parsedUpfluenceData, key, val)
                }
            },

            // format summed values
            formatSummedValue(num) {
                if (num >= 1_000_000_000) {
                    return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
                }
                if (num >= 1_000_000) {
                    return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
                }
                if (num >= 1_000) {
                    return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'
                }
                if (num <= 0 || !num) {
                    return 'N/A'
                }
                return num.toFixed(0).toString()
            },

            // format percentages values
            formatPercentages(num) {
                if (num === 0 || !isFinite(num)) {
                    return 'N/A'
                }
                if (num > 100) {
                    return '100%'
                }
                return num.toFixed(0).toString() + '%'
            },

            // format progress from percentages (for bootstrap progress)
            formatProgress(perct) {
                if (perct === 'N/A') {
                    return '0'
                }
                return perct.replace('%', '')
            },

            // format platform specific data keys
            formatPltfmSpcfcDatakeys(dt) {
                return dt
                    .split('_')
                    .map((word) => word[0].toUpperCase() + word.substring(1))
                    .join(' ')
            },

            /**
             * sorts demographics data and take top 4 data points
             * preps data for template
             */
            sortDemogrphcs(data, numOfPlatforms) {
                // manipulate data to take top 4
                let sortingData = {}
                let finalData = {}

                // sort through initial data and add up all values for multiple upfluence acct
                for (let i = 0; i < data.length; i++) {
                    for (const [key, perct] of Object.entries(data[i])) {
                        if (Object.keys(sortingData).includes(key)) {
                            sortingData[key] += perct
                        } else {
                            sortingData[key] = perct
                        }
                    }
                }

                // taking the top 4 values of sortingData
                for (let i = 0; i < 4; i++) {
                    let values = Object.values(sortingData)
                    let max = Math.max(...values)
                    let key = Object.keys(sortingData).filter(function (key) {
                        return sortingData[key] === max
                    })[0]

                    if (key === undefined) break

                    // assign data & delete key in sortingArr to start again
                    finalData[key] = (max / numOfPlatforms) * 100
                    delete sortingData[key]
                }

                return finalData
            },

            // iterate through each platform and fetches each platform's data
            fetchPltfmDemogrphcsCollection(pltfmData) {
                let pltfmSpecifcData = []

                for (const pltfm of Object.keys(pltfmData)) {
                    if (pltfm === 'facebooks') {
                        let pltfmSpcfcData = this.fetchPltfmData(pltfmData, pltfm, {
                            key1: 'average_likes',
                            key2: 'average_comments'
                        })

                        pltfmSpecifcData.push(pltfmSpcfcData)
                    } else if (pltfm === 'twitters') {
                        let pltfmSpcfcData = this.fetchPltfmData(pltfmData, pltfm, {
                            key1: 'average_favorites',
                            key2: 'average_retweets'
                        })

                        pltfmSpecifcData.push(pltfmSpcfcData)
                    } else if (pltfm === 'instagrams') {
                        let pltfmSpcfcData = this.fetchPltfmData(pltfmData, pltfm, {
                            key1: 'average_likes',
                            key2: 'average_comments'
                        })

                        pltfmSpecifcData.push(pltfmSpcfcData)
                    } else if (pltfm === 'youtubes') {
                        let pltfmSpcfcData = this.fetchPltfmData(pltfmData, pltfm, {
                            key1: 'average_likes',
                            key2: 'average_views'
                        })

                        pltfmSpecifcData.push(pltfmSpcfcData)
                    } else if (pltfm === 'tiktoks') {
                        let pltfmSpcfcData = this.fetchPltfmData(pltfmData, pltfm, {
                            key1: 'average_likes',
                            key2: 'average_comments'
                        })

                        pltfmSpecifcData.push(pltfmSpcfcData)
                    } else if (pltfm === 'pinterests') {
                        console.error('pinterests API set not available')
                    } else if (pltfm === 'twitches') {
                        console.error('twitches API set not available')
                    }
                }

                return pltfmSpecifcData
            },

            // fetches and add up all data points of interest for a pltfm
            fetchPltfmData(pltfmData, pltfm, { key1, key2 }) {
                let [numOfPlatforms, followers, engagement_rate, dataPt1, dataPt2] = [
                    0, 0, 0, 0, 0
                ]

                let pltfmSpcfcData = {}

                for (let i = 0; i < pltfmData[pltfm].length; i++) {
                    if (pltfmData[pltfm][i].followers)
                        followers += pltfmData[pltfm][i].followers
                    if (pltfmData[pltfm][i].engagement_rate)
                        engagement_rate += pltfmData[pltfm][i].engagement_rate
                    if (pltfmData[pltfm][i][key1]) dataPt1 += pltfmData[pltfm][i][key1]
                    if (pltfmData[pltfm][i][key2]) dataPt2 += pltfmData[pltfm][i][key2]
                }

                numOfPlatforms += pltfmData[pltfm].length

                pltfmSpcfcData['platform'] = pltfm
                pltfmSpcfcData['followers'] = followers
                pltfmSpcfcData['engagement_rate'] = (engagement_rate / numOfPlatforms) * 100
                pltfmSpcfcData[key1] = dataPt1 / numOfPlatforms
                pltfmSpcfcData[key2] = dataPt2 / numOfPlatforms

                return pltfmSpcfcData
            },

            /**
             * sort through platformSpcfcData set and
             * take the first 3 ordered by followers
             */
            sortPltfmCollectionData(pltfmSpcfcData) {
                function compare(a, b) {
                    if (a.followers < b.followers) {
                        return 1
                    }
                    if (a.followers > b.followers) {
                        return -1
                    }
                    return 0
                }

                return pltfmSpcfcData.sort(compare)
            }
        },

        computed: {
            /**
             * checks if age group data is empty
             * NOTE: since backend will send this data regardless if it is available
             * we must check if all value is 0, if so, data is empty.
             */
            emptyAgeStats() {
                return Object.values(this.parsedUpfluenceData.overall_stats.ageStat).every(
                    (val) => val === 0
                )
            },

            /**
             * takes top four of the overall_stats/ageStats
             */
            topThreeAgeGroupData() {
                return Object.entries(this.parsedUpfluenceData.overall_stats.ageStat)
                    .slice(0, 4)
                    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
            },

            /**
             * iterate through array of specific stats from laravel
             * rename social media keys to get rid of the Stats part
             * so that backend stats match with how we take specific paltform stats in vue
             */
            parsedPltfmSpecificStats() {
                let parsedStats = {}

                for (const [key, value] of Object.entries(
                    this.parsedUpfluenceData.specific_stats
                )) {
                    if (key === 'twitchStat') {
                        parsedStats['twitches'] = value
                        break
                    }
                    parsedStats[key.replace('Stat', 's')] = value
                }

                return parsedStats
            },

            /**
             * iterate through upfluencedata accts
             * iterate through upfluencedata acct keys
             * add or concat arrays for each specfic platform
             * iterate through each platform and add its necessary stats
             */
            platformSpecificStats() {
                let pltfmData = {}

                for (const [pltfm, data] of Object.entries(this.parsedPltfmSpecificStats)) {
                    if (this.socialPlatforms.includes(pltfm) && data) {
                        if (!Object.prototype.hasOwnProperty.call(pltfmData, pltfm)) {
                            pltfmData[pltfm] = data
                        } else {
                            pltfmData[pltfm] = pltfmData[pltfm].concat(data)
                        }
                    }
                }

                return this.sortPltfmCollectionData(
                    this.fetchPltfmDemogrphcsCollection(pltfmData)
                ).slice(0, 3)
            },

            /**
             * iterate through the platformSpecificStats
             * format all values either to be percentages or summed values
             */
            platformSpecificFormattedData() {
                let pltfmSpcfcFmtData = []
                for (let i = 0; i < this.platformSpecificStats.length; i++) {
                    let pltfmSpcfcData = this.platformSpecificStats[i]

                    for (const key of Object.keys(pltfmSpcfcData)) {
                        if (this.prcntFmtKeys.includes(key)) {
                            pltfmSpcfcData[key] = this.formatPercentages(pltfmSpcfcData[key])
                        } else if (this.summedFmtKeys.includes(key)) {
                            pltfmSpcfcData[key] = this.formatSummedValue(pltfmSpcfcData[key])
                        }
                    }

                    pltfmSpcfcFmtData.push(pltfmSpcfcData)
                }

                return pltfmSpcfcFmtData
            }
        }
    }
</script>
<style lang="scss" scoped>
    .upfluence-profile {
        h2,
        h3,
        h4 {
            font-family: Instrument Sans;
            text-transform: none;
            font-weight: bolder;
        }

        .overall-stats {
            h4 {
                margin-bottom: 30px;
            }

            .overall-audience-data {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                margin-bottom: 60px;

                .social-reach {
                    order: 1;
                    flex: 1 1 auto;

                    .social-reach-data {
                        margin-left: 0;
                        margin-right: 20px;
                    }
                }
                .total-engagement {
                    order: 2;
                    flex: 1 1 auto;
                    .total-engagement-data {
                        margin-right: 20px;
                    }
                }
                .real-followers {
                    order: 3;
                    flex: 1 1 auto;
                }

                h2 {
                    margin-bottom: 0px;
                }
                p {
                    font-weight: bold;
                    margin-bottom: 0px;
                }
            }

            .overall-demographics-data {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;

                .gender-demographics {
                    order: 1;
                    flex: 1 1 auto;
                    width: 90px;

                    .male-data {
                        margin-bottom: 30px;
                    }

                    h2 {
                        svg {
                            path {
                                stroke: #000000;
                                stroke-width: 1px;
                            }
                        }
                    }
                }

                .age-demographics {
                    order: 2;
                    flex: 1 1 auto;
                    width: 120px;

                    .age-stats-container {
                        display: flex;
                        justify-content: flex-start;

                        .age-range {
                            flex: 1 1 auto;
                            max-width: 70px;
                            width: 100%;

                            p {
                                font-size: 14px;
                                font-weight: bold;
                                text-align: right;
                                padding-right: 10px;
                            }
                        }

                        .bootstrap-progressbar {
                            flex: 1 1 auto;

                            .progress {
                                width: 75px;
                                height: 20px;

                                .progress-bar {
                                    padding-left: 0;
                                    padding-right: 0;
                                    min-width: 30%;
                                }
                            }
                        }
                    }
                    .age-stats-label {
                        p {
                            font-weight: bold;
                            text-align: center;
                        }
                    }
                }
                .empty-age-stats {
                    order: 2;
                    flex: 1 1 auto;
                    width: 120;

                    p {
                        font-weight: bold;
                        font-size: 20px;
                    }
                }

                .countries-demographics {
                    order: 3;
                    flex: 1 1 auto;
                    width: 100px;

                    .countries-stats-container {
                        display: flex;
                        justify-content: flex-start;

                        .country-name {
                            flex: 1 1 auto;
                            max-width: 70px;
                            width: 100%;

                            p {
                                font-size: 14px;
                                font-weight: bold;
                                text-align: right;
                                padding-right: 10px;
                            }
                        }

                        .bootstrap-progressbar {
                            flex: 1 1 auto;
                            .progress {
                                width: 75px;
                                height: 20px;

                                .progress-bar {
                                    padding-left: 0;
                                    padding-right: 0;
                                    min-width: 30%;
                                }
                            }
                        }
                    }
                    .countries-stats-label {
                        p {
                            font-weight: bold;
                            text-align: center;
                        }
                    }
                }
                .empty-countries-stats {
                    order: 2;
                    flex: 1 1 auto;
                    width: 120;

                    p {
                        font-weight: bold;
                        font-size: 20px;
                    }
                }

                .cities-demographics {
                    order: 4;
                    flex: 1 1 auto;
                    .cities-stats-container {
                        display: flex;
                        justify-content: flex-start;

                        .city-name {
                            flex: 1 1 auto;
                            max-width: 130px;
                            width: 100%;

                            p {
                                font-size: 14px;
                                font-weight: bold;
                                text-align: right;
                                padding-right: 10px;
                            }
                        }

                        .bootstrap-progressbar {
                            flex: 1 1 auto;
                            .progress {
                                width: 75px;
                                height: 20px;

                                .progress-bar {
                                    padding-left: 0;
                                    padding-right: 0;
                                    min-width: 30%;
                                }
                            }
                        }
                    }
                    .cities-stats-label {
                        p {
                            font-weight: bold;
                            text-align: center;
                        }
                    }
                }
                .empty-cities-stats {
                    order: 2;
                    flex: 1 1 auto;
                    width: 120;

                    p {
                        font-weight: bold;
                        font-size: 20px;
                    }
                }
            }
        }
        .specific-stats {
            .platform-specific-container {
                display: flex;
                flex-direction: row;
                justify-content: left;

                .individual-platform {
                    margin-left: 30px;
                    flex: 1 1 auto;

                    .data-container {
                        .platform-icon {
                            position: relative;
                            left: -50px;
                            top: 30px;

                            img {
                                width: 30px;
                                height: 30px;
                            }
                        }

                        .platform-data {
                            p {
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
            .empty-specific-stats {
                p {
                    font-weight: bold;
                    font-size: 18px;
                }
            }
        }
    }
</style>
